function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import './signature.scss';
import SignaturePad from 'signature_pad';
import CustomHTMLElement from 'html-element';
import Popover from 'popover';

var SignatureInput = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(SignatureInput, _CustomHTMLElement);

  var _super = _createSuper(SignatureInput);

  function SignatureInput() {
    _classCallCheck(this, SignatureInput);

    return _super.apply(this, arguments);
  }

  _createClass(SignatureInput, [{
    key: "_runSetup",
    value: function _runSetup() {
      _get(_getPrototypeOf(SignatureInput.prototype), "_runSetup", this).call(this);

      this.name = this.getAttribute('data-name');
      this.fieldTitle = this.getAttribute('data-title');
      this.buttonText = this.getAttribute('data-button-text') || 'Click to Sign';
      this.popoverText = this.getAttribute('data-popover-text') || 'Use your mouse or finger to draw your signature above';
      this.clearText = this.getAttribute('data-clear-text') || 'Clear';
      this.useText = this.getAttribute('data-use-text') || 'Use';
      this.createElements();
      this.addEventListener('click', this.buttonClicked.bind(this));
      this.updateInputs(this.signatureValue);
    }
  }, {
    key: "signatureValue",
    get: function get() {
      return this.hiddenInput.value;
    },
    set: function set(newValue) {
      this.hiddenInput.value = newValue;
      this.updateInputs(newValue);
    } //////////

  }, {
    key: "createElements",
    value: function createElements() {
      // Hidden Input
      this.hiddenInput = this.querySelector('input[type=hidden]');

      if (!this.hiddenInput) {
        this.hiddenInput = document.createElement('input');
        this.hiddenInput.type = 'hidden';
        this.hiddenInput.name = this.name;
        this.appendChild(this.hiddenInput);
      } // Button


      this.buttonElement = document.createElement('a');
      this.buttonElement.classList.add('button');
      this.buttonElement.classList.add('button--style-outline');
      this.buttonElement.innerText = this.buttonText;
      this.appendChild(this.buttonElement); // Image

      this.imageElement = document.createElement('img');
      this.appendChild(this.imageElement); // Popover

      this.popoverWindow = new Popover();
      this.popoverWindow.title = this.fieldTitle;
      var clearButton = document.createElement('a');
      clearButton.classList.add('button');
      clearButton.classList.add('button--style-outline');
      clearButton.classList.add('button--color-red');
      clearButton.innerText = this.clearText;
      clearButton.addEventListener('click', this.clearClicked.bind(this));
      this.popoverWindow.footer.appendChild(clearButton);
      var useButton = document.createElement('a');
      useButton.classList.add('button');
      useButton.classList.add('button--color-green');
      useButton.innerText = this.useText;
      useButton.addEventListener('click', this.useClicked.bind(this));
      this.popoverWindow.footer.appendChild(useButton);
      var signatureContent = document.createElement('div');
      signatureContent.classList.add('signature-content');
      var instructionElement = document.createElement('p');
      instructionElement.innerText = this.popoverText;
      signatureContent.appendChild(instructionElement);
      this.canvas = document.createElement('canvas');
      this.signaturePad = new SignaturePad(this.canvas);
      signatureContent.appendChild(this.canvas);
      this.popoverWindow.body.appendChild(signatureContent);
    }
  }, {
    key: "updateInputs",
    value: function updateInputs(object) {
      if (object) {
        this.imageElement.src = object;
        this.classList.remove('signature-input--placeholder');
      } else {
        this.imageElement.src = 'data:image/gif;base64,R0lGODlhAQABAPAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
        this.classList.add('signature-input--placeholder');
      }
    }
  }, {
    key: "resizeCanvas",
    value: function resizeCanvas() {
      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      this.canvas.width = this.canvas.offsetWidth * ratio;
      this.canvas.height = this.canvas.offsetHeight * ratio;
      this.canvas.getContext('2d').scale(ratio, ratio);
      this.signaturePad.clear();
    } //////////

  }, {
    key: "buttonClicked",
    value: function buttonClicked() {
      this.popoverWindow.show();
      this.resizeCanvas();
      var object = this.signatureValue;

      if (object) {
        this.signaturePad.fromDataURL(object);
      } else {
        this.signaturePad.clear();
      }
    }
  }, {
    key: "clearClicked",
    value: function clearClicked() {
      this.signaturePad.clear();
    }
  }, {
    key: "useClicked",
    value: function useClicked() {
      if (this.signaturePad.isEmpty()) {
        return;
      }

      this.signatureValue = this.signaturePad.toDataURL('image/svg+xml');
      this.popoverWindow.hide();
    }
  }]);

  return SignatureInput;
}(CustomHTMLElement);

window.customElements.define('signature-input', SignatureInput);